// extracted by mini-css-extract-plugin
export default {"nav":"Sidebar_nav__fYpbP","list":"Sidebar_list__0u-Dq"};